export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-home-smile-line',
      title: 'Kaliteli Yaşam',
      description: 'A+ sınıf malzemeler ve modern tasarım anlayışı ile inşa edilen dairelerimiz, konforun ve estetiğin mükemmel birleşimini sunuyor.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Stratejik Konum',
      description: 'Küçükçekmece İstasyon Mahallesi\'nde, toplu taşıma araçlarına, alışveriş merkezlerine ve sosyal tesislere yürüme mesafesinde.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenli Yaşam',
      description: '7/24 güvenlik, kapalı otopark, yangın alarm sistemi ve modern güvenlik teknolojileri ile ailenizin güvenliği bizim önceliğimiz.'
    },
    {
      icon: 'ri-plant-line',
      title: 'Yeşil Alanlar',
      description: 'Geniş peyzaj alanları, çocuk oyun parkları ve dinlenme alanları ile doğayla iç içe bir yaşam sunuyoruz.'
    },
    {
      icon: 'ri-community-line',
      title: 'Sosyal Tesisler',
      description: 'Fitness merkezi, kapalı yüzme havuzu, sauna ve sosyal aktivite alanları ile zenginleştirilmiş yaşam alanları.'
    },
    {
      icon: 'ri-car-line',
      title: 'Kolay Ulaşım',
      description: 'E-5 ve TEM otoyollarına yakın konumu ile İstanbul\'un her noktasına hızlı ve kolay ulaşım imkanı.'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Neden KARE YAPI İNŞAAT?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Modern yaşamın tüm avantajlarını bir arada sunan KARE YAPI İNŞAAT, 
            aileniz için en doğru yatırım seçeneğidir
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}